exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/holidays-report/holidays-report.component.css
// module id = 343
// module chunks = 0